import { render, staticRenderFns } from "./SuggestionListWrapper.vue?vue&type=template&id=721c3a10&scoped=true"
import script from "./SuggestionListWrapper.vue?vue&type=script&lang=js"
export * from "./SuggestionListWrapper.vue?vue&type=script&lang=js"
import style0 from "./SuggestionListWrapper.vue?vue&type=style&index=0&id=721c3a10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721c3a10",
  null
  
)

export default component.exports